import type { Thing, WithContext } from "schema-dts";

export type StructuredDataSchema = Thing | WithContext<Thing>;

export function getStructuredDataScript(schema: StructuredDataSchema): string {
	return `<script type="application/ld+json">${JSON.stringify(schema)}</script>`;
}
